// Orders, fills, positions, accounts (SPEC §7.3, §9). Carried on /v1/stream/trading only.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/trading.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BracketRole, OrderState, OrderType, Origin, Side, Tif, TradingEnvironment } from "./common_pb";
import { file_helm_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file helm/v1/trading.proto.
 */
export const file_helm_v1_trading: GenFile = /*@__PURE__*/
  fileDesc("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", [file_helm_v1_common]);

/**
 * One exit leg of a bracket (ADR-0017, ADR-0025): `qty` contracts leave at a profit target and are
 * protected by their own stop. Distances are whole ticks from the entry's average fill price, always
 * positive; the entry side places them (long: target above, stop below).
 *
 * @generated from message helm.v1.BracketLeg
 */
export type BracketLeg = Message<"helm.v1.BracketLeg"> & {
  /**
   * > 0
   *
   * @generated from field: uint32 target_ticks = 1;
   */
  targetTicks: number;

  /**
   * > 0
   *
   * @generated from field: uint32 qty = 2;
   */
  qty: number;

  /**
   * > 0
   *
   * @generated from field: uint32 stop_ticks = 3;
   */
  stopTicks: number;
};

/**
 * Describes the message helm.v1.BracketLeg.
 * Use `create(BracketLegSchema)` to create a new message.
 */
export const BracketLegSchema: GenMessage<BracketLeg> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 0);

/**
 * Per-entry bracket (SPEC §9.4). Managed by the gateway (ADR-0025): the children are placed through
 * OrderRouter::submit as the entry fills, OCO per leg, AUTO-tagged.
 *
 * @generated from message helm.v1.BracketSpec
 */
export type BracketSpec = Message<"helm.v1.BracketSpec"> & {
  /**
   * 1..3 legs; Σ qty = the order qty
   *
   * @generated from field: repeated helm.v1.BracketLeg legs = 1;
   */
  legs: BracketLeg[];

  /**
   * 0 = no auto-breakeven
   *
   * @generated from field: uint32 breakeven_trigger_ticks = 3;
   */
  breakevenTriggerTicks: number;

  /**
   * 0 = no auto-trail
   *
   * @generated from field: uint32 trail_trigger_ticks = 5;
   */
  trailTriggerTicks: number;

  /**
   * stop distance behind the price once the trail is active
   *
   * @generated from field: uint32 trail_distance_ticks = 6;
   */
  trailDistanceTicks: number;

  /**
   * entered in $, converted to ticks client-side at submit (§9.4), for display
   *
   * @generated from field: bool dollar_mode = 7;
   */
  dollarMode: boolean;

  /**
   * the trail moves the stop in steps of this many ticks (≥ 1)
   *
   * @generated from field: uint32 trail_step_ticks = 8;
   */
  trailStepTicks: number;

  /**
   * stop moves to entry + this (in the trade's favour; may be negative)
   *
   * @generated from field: sint32 breakeven_offset_ticks = 9;
   */
  breakevenOffsetTicks: number;
};

/**
 * Describes the message helm.v1.BracketSpec.
 * Use `create(BracketSpecSchema)` to create a new message.
 */
export const BracketSpecSchema: GenMessage<BracketSpec> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 1);

/**
 * @generated from message helm.v1.PlaceOrder
 */
export type PlaceOrder = Message<"helm.v1.PlaceOrder"> & {
  /**
   * UUIDv7 from the client; duplicates rejected for 24 h
   *
   * @generated from field: string client_order_id = 1;
   */
  clientOrderId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 3;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.Side side = 4;
   */
  side: Side;

  /**
   * @generated from field: helm.v1.OrderType type = 5;
   */
  type: OrderType;

  /**
   * @generated from field: uint32 qty = 6;
   */
  qty: number;

  /**
   * 0 = unset
   *
   * @generated from field: sint64 limit_ticks = 7;
   */
  limitTicks: bigint;

  /**
   * @generated from field: sint64 stop_ticks = 8;
   */
  stopTicks: bigint;

  /**
   * @generated from field: uint32 trail_ticks = 9;
   */
  trailTicks: number;

  /**
   * @generated from field: helm.v1.Tif tif = 10;
   */
  tif: Tif;

  /**
   * @generated from field: helm.v1.BracketSpec bracket = 11;
   */
  bracket?: BracketSpec | undefined;

  /**
   * @generated from field: helm.v1.Origin origin = 12;
   */
  origin: Origin;

  /**
   * @generated from field: bool confirmed_by_user = 13;
   */
  confirmedByUser: boolean;

  /**
   * @generated from field: string strategy_instance_id = 14;
   */
  strategyInstanceId: string;

  /**
   * A take-profit (LIMIT) or stop-loss (STOP_MARKET) for the whole open position of (account,
   * symbol), dragged off the chart's position line (SPEC 9.3): qty = the position's size, side =
   * the side that closes it, no bracket. The gateway attaches it to the position's position bracket
   * (one OCO pair that follows the position's size) and sends it through the one submit path.
   *
   * @generated from field: bool protect_position = 15;
   */
  protectPosition: boolean;
};

/**
 * Describes the message helm.v1.PlaceOrder.
 * Use `create(PlaceOrderSchema)` to create a new message.
 */
export const PlaceOrderSchema: GenMessage<PlaceOrder> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 2);

/**
 * @generated from message helm.v1.ModifyOrder
 */
export type ModifyOrder = Message<"helm.v1.ModifyOrder"> & {
  /**
   * @generated from field: string client_order_id = 1;
   */
  clientOrderId: string;

  /**
   * 0 = unchanged
   *
   * @generated from field: uint32 qty = 2;
   */
  qty: number;

  /**
   * 0 = unchanged
   *
   * @generated from field: sint64 limit_ticks = 3;
   */
  limitTicks: bigint;

  /**
   * @generated from field: sint64 stop_ticks = 4;
   */
  stopTicks: bigint;

  /**
   * @generated from field: bool confirmed_by_user = 5;
   */
  confirmedByUser: boolean;
};

/**
 * Describes the message helm.v1.ModifyOrder.
 * Use `create(ModifyOrderSchema)` to create a new message.
 */
export const ModifyOrderSchema: GenMessage<ModifyOrder> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 3);

/**
 * @generated from message helm.v1.CancelOrder
 */
export type CancelOrder = Message<"helm.v1.CancelOrder"> & {
  /**
   * @generated from field: string client_order_id = 1;
   */
  clientOrderId: string;
};

/**
 * Describes the message helm.v1.CancelOrder.
 * Use `create(CancelOrderSchema)` to create a new message.
 */
export const CancelOrderSchema: GenMessage<CancelOrder> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 4);

/**
 * @generated from message helm.v1.ExitAction
 */
export type ExitAction = Message<"helm.v1.ExitAction"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * empty = whole account
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.ExitKind kind = 3;
   */
  kind: ExitKind;

  /**
   * @generated from field: bool confirmed_by_user = 4;
   */
  confirmedByUser: boolean;

  /**
   * Fresh per click (UUID). Reverse & Cxl is refused as DUPLICATE when the same id arrives again
   * within 24 h, so a resent frame can never reverse twice.
   *
   * @generated from field: string client_request_id = 5;
   */
  clientRequestId: string;
};

/**
 * Describes the message helm.v1.ExitAction.
 * Use `create(ExitActionSchema)` to create a new message.
 */
export const ExitActionSchema: GenMessage<ExitAction> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 5);

/**
 * The owner's explicit "Force exit anyway" for an exit HELM is holding back (ADR-0050). A Flatten /
 * Exit & Cxl / risk liquidation / copy flatten never sends an exit for quantity a protective order
 * whose cancel Rithmic has not confirmed could also close; past `flatten_pending_for` it raises an
 * Error `FLATTEN_WAITING` notice instead. This is the only command that sends that held part: a
 * market exit for the whole remaining position in scope, which REVERSES the account if the
 * protective order also fills. Refused (`CONFIRM_REQUIRED`) unless `confirmed_by_user`, and
 * (`NOTHING_HELD`) unless such an exit is held and its wait is over. Never copied to followers.
 *
 * @generated from message helm.v1.ForceExit
 */
export type ForceExit = Message<"helm.v1.ForceExit"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * empty = every held exit of the account
   *
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: bool confirmed_by_user = 3;
   */
  confirmedByUser: boolean;

  /**
   * the account's Rithmic login (AccountUpdate.login_id); empty = the session's own
   *
   * @generated from field: string login_id = 4;
   */
  loginId: string;
};

/**
 * Describes the message helm.v1.ForceExit.
 * Use `create(ForceExitSchema)` to create a new message.
 */
export const ForceExitSchema: GenMessage<ForceExit> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 6);

/**
 * The owner's "Resync with Rithmic" for one Rithmic login (ADR-0059): every account of the login is
 * checked against Rithmic's working orders and today's order history, the way a reconnect's
 * bootstrap is — orders Rithmic no longer lists leave the book, orders it lists that the book
 * lacks are imported, a cancel / modify Rithmic never answered takes Rithmic's state — and the
 * positions are read again from the PnL plant. Nothing is cancelled or sent. Refused without
 * `confirmed_by_user` (CONFIRM_REQUIRED), while an exit runs or is held (EXIT_IN_PROGRESS), while a
 * submit has no answer yet (ORDERS_IN_FLIGHT) or before READY. The result says it started; the
 * outcome comes as an Info / Warn notice RESYNC_DONE ("Resynced with Rithmic: 0 working order(s),
 * positions flat; 2 stale order(s) cleared").
 *
 * @generated from message helm.v1.Resync
 */
export type Resync = Message<"helm.v1.Resync"> & {
  /**
   * the login (AccountUpdate.login_id); empty = the session's own
   *
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: bool confirmed_by_user = 2;
   */
  confirmedByUser: boolean;
};

/**
 * Describes the message helm.v1.Resync.
 * Use `create(ResyncSchema)` to create a new message.
 */
export const ResyncSchema: GenMessage<Resync> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 7);

/**
 * Position bracket for the whole net position of (account, symbol) (SPEC §9.5).
 *
 * @generated from message helm.v1.SetPositionBracket
 */
export type SetPositionBracket = Message<"helm.v1.SetPositionBracket"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Each leg is either offset-anchored (offset_ticks, moves with avg price) or price-anchored.
   *
   * @generated from field: uint32 stop_offset_ticks = 4;
   */
  stopOffsetTicks: number;

  /**
   * @generated from field: sint64 stop_price_ticks = 5;
   */
  stopPriceTicks: bigint;

  /**
   * @generated from field: uint32 target_offset_ticks = 6;
   */
  targetOffsetTicks: number;

  /**
   * @generated from field: sint64 target_price_ticks = 7;
   */
  targetPriceTicks: bigint;

  /**
   * @generated from field: bool dollar_mode = 8;
   */
  dollarMode: boolean;

  /**
   * @generated from field: sint64 risk_cents = 9;
   */
  riskCents: bigint;

  /**
   * @generated from field: sint64 profit_cents = 10;
   */
  profitCents: bigint;
};

/**
 * Describes the message helm.v1.SetPositionBracket.
 * Use `create(SetPositionBracketSchema)` to create a new message.
 */
export const SetPositionBracketSchema: GenMessage<SetPositionBracket> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 8);

/**
 * @generated from message helm.v1.CommandResult
 */
export type CommandResult = Message<"helm.v1.CommandResult"> & {
  /**
   * @generated from field: string req_id = 1;
   */
  reqId: string;

  /**
   * @generated from field: bool ok = 2;
   */
  ok: boolean;

  /**
   * RISK_BLOCKED | LOCKOUT_ACTIVE | SESSION_NOT_READY | PRICE_COLLAR | MAX_QTY | ...
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * shown verbatim in a toast
   *
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * accepted PlaceOrder: the gateway's order id (the Rithmic user_tag), = OrderEvent.client_order_id
   *
   * @generated from field: string order_id = 5;
   */
  orderId: string;
};

/**
 * Describes the message helm.v1.CommandResult.
 * Use `create(CommandResultSchema)` to create a new message.
 */
export const CommandResultSchema: GenMessage<CommandResult> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 9);

/**
 * @generated from message helm.v1.OrderEvent
 */
export type OrderEvent = Message<"helm.v1.OrderEvent"> & {
  /**
   * @generated from field: string client_order_id = 1;
   */
  clientOrderId: string;

  /**
   * @generated from field: string basket_id = 2;
   */
  basketId: string;

  /**
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 4;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.Side side = 5;
   */
  side: Side;

  /**
   * @generated from field: helm.v1.OrderType type = 6;
   */
  type: OrderType;

  /**
   * @generated from field: uint32 qty = 7;
   */
  qty: number;

  /**
   * @generated from field: uint32 filled = 8;
   */
  filled: number;

  /**
   * @generated from field: sint64 avg_fill_ticks = 9;
   */
  avgFillTicks: bigint;

  /**
   * @generated from field: sint64 limit_ticks = 10;
   */
  limitTicks: bigint;

  /**
   * @generated from field: sint64 stop_ticks = 11;
   */
  stopTicks: bigint;

  /**
   * @generated from field: uint32 trail_ticks = 12;
   */
  trailTicks: number;

  /**
   * @generated from field: helm.v1.Tif tif = 13;
   */
  tif: Tif;

  /**
   * @generated from field: helm.v1.OrderState state = 14;
   */
  state: OrderState;

  /**
   * @generated from field: helm.v1.Origin origin = 15;
   */
  origin: Origin;

  /**
   * placed outside HELM (no user_tag); never auto-managed
   *
   * @generated from field: bool external = 16;
   */
  external: boolean;

  /**
   * @generated from field: string parent_id = 17;
   */
  parentId: string;

  /**
   * @generated from field: string oco_group = 18;
   */
  ocoGroup: string;

  /**
   * @generated from field: helm.v1.BracketRole bracket_role = 19;
   */
  bracketRole: BracketRole;

  /**
   * @generated from field: fixed64 created_ns = 20;
   */
  createdNs: bigint;

  /**
   * @generated from field: fixed64 updated_ns = 21;
   */
  updatedNs: bigint;

  /**
   * @generated from field: string reject_reason = 22;
   */
  rejectReason: string;

  /**
   * contracts ahead at our price (MBO), 0 when unknown
   *
   * @generated from field: uint32 queue_ahead = 23;
   */
  queueAhead: number;

  /**
   * 1..3 for a bracket child (TARGET/STOP), 0 otherwise
   *
   * @generated from field: uint32 bracket_leg = 24;
   */
  bracketLeg: number;

  /**
   * the stored Rithmic login this order is on (empty: the env dev login)
   *
   * @generated from field: string login_id = 25;
   */
  loginId: string;
};

/**
 * Describes the message helm.v1.OrderEvent.
 * Use `create(OrderEventSchema)` to create a new message.
 */
export const OrderEventSchema: GenMessage<OrderEvent> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 10);

/**
 * @generated from message helm.v1.FillEvent
 */
export type FillEvent = Message<"helm.v1.FillEvent"> & {
  /**
   * @generated from field: string fill_id = 1;
   */
  fillId: string;

  /**
   * @generated from field: string client_order_id = 2;
   */
  clientOrderId: string;

  /**
   * @generated from field: string basket_id = 3;
   */
  basketId: string;

  /**
   * @generated from field: string account_id = 4;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 5;
   */
  symbol: string;

  /**
   * @generated from field: helm.v1.Side side = 6;
   */
  side: Side;

  /**
   * @generated from field: uint32 qty = 7;
   */
  qty: number;

  /**
   * @generated from field: sint64 price_ticks = 8;
   */
  priceTicks: bigint;

  /**
   * @generated from field: fixed64 ts_ns = 9;
   */
  tsNs: bigint;

  /**
   * @generated from field: sint64 fee_cents = 10;
   */
  feeCents: bigint;

  /**
   * @generated from field: bool fee_is_estimate = 11;
   */
  feeIsEstimate: boolean;

  /**
   * @generated from field: bool external = 12;
   */
  external: boolean;

  /**
   * as OrderEvent.login_id
   *
   * @generated from field: string login_id = 13;
   */
  loginId: string;
};

/**
 * Describes the message helm.v1.FillEvent.
 * Use `create(FillEventSchema)` to create a new message.
 */
export const FillEventSchema: GenMessage<FillEvent> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 11);

/**
 * @generated from message helm.v1.PositionUpdate
 */
export type PositionUpdate = Message<"helm.v1.PositionUpdate"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: sint32 net_qty = 3;
   */
  netQty: number;

  /**
   * rounded for display; exact rational kept gateway-side
   *
   * @generated from field: sint64 avg_price_ticks = 4;
   */
  avgPriceTicks: bigint;

  /**
   * @generated from field: sint64 realized_cents = 5;
   */
  realizedCents: bigint;

  /**
   * @generated from field: sint64 open_pnl_cents = 6;
   */
  openPnlCents: bigint;

  /**
   * fills-derived vs PnL-plant disagree > 2 s (SPEC §6.10 inv. 3)
   *
   * @generated from field: bool mismatch = 7;
   */
  mismatch: boolean;

  /**
   * Σ price_ticks × qty over the open contracts (SPEC §8), 0 when flat. The exact average is
   * open_cost_ticks / |net_qty| (a rational); clients compute P&L from this, never from the
   * rounded avg_price_ticks. Saturates at the sint64 range (never reached by real prices).
   *
   * @generated from field: sint64 open_cost_ticks = 8;
   */
  openCostTicks: bigint;

  /**
   * as OrderEvent.login_id
   *
   * @generated from field: string login_id = 9;
   */
  loginId: string;
};

/**
 * Describes the message helm.v1.PositionUpdate.
 * Use `create(PositionUpdateSchema)` to create a new message.
 */
export const PositionUpdateSchema: GenMessage<PositionUpdate> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 12);

/**
 * @generated from message helm.v1.AccountUpdate
 */
export type AccountUpdate = Message<"helm.v1.AccountUpdate"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string login_id = 2;
   */
  loginId: string;

  /**
   * @generated from field: string rithmic_account_id = 3;
   */
  rithmicAccountId: string;

  /**
   * @generated from field: string alias = 4;
   */
  alias: string;

  /**
   * @generated from field: bool is_sim = 5;
   */
  isSim: boolean;

  /**
   * Broker-reported fields only (GPT-040). No local balance, fill, mark, profile or override
   * fallback. A field Rithmic has not reported in the current PnL-plant session and trading day
   * remains absent; one it reported keeps its last value (ADR-0056, field_times).
   * Availability requires broker_finance_current;
   * a nonzero timestamp alone does not establish successful current-source coverage.
   *
   * 451 account_balance; do not assume cash or add open P&L
   *
   * @generated from field: optional sint64 balance_cents = 6;
   */
  balanceCents?: bigint | undefined;

  /**
   * 451 day_closed_pnl only
   *
   * @generated from field: optional sint64 realized_today_cents = 7;
   */
  realizedTodayCents?: bigint | undefined;

  /**
   * 451 open_position_pnl only
   *
   * @generated from field: optional sint64 unrealized_cents = 8;
   */
  unrealizedCents?: bigint | undefined;

  /**
   * broker ssboe/usecs; 0 = broker time unavailable, never local receipt time
   *
   * @generated from field: fixed64 ts_ns = 9;
   */
  tsNs: bigint;

  /**
   * where this account's orders go, gateway-derived (ADR-0021)
   *
   * @generated from field: helm.v1.TradingEnvironment environment = 10;
   */
  environment: TradingEnvironment;

  /**
   * 451 day_pnl only; never reconstructed
   *
   * @generated from field: optional sint64 day_pnl_cents = 11;
   */
  dayPnlCents?: bigint | undefined;

  /**
   * 451 cash_on_hand, distinct from account_balance
   *
   * @generated from field: optional sint64 cash_on_hand_cents = 12;
   */
  cashOnHandCents?: bigint | undefined;

  /**
   * successful current-source snapshot; field presence still required
   *
   * @generated from field: bool broker_finance_current = 13;
   */
  brokerFinanceCurrent: boolean;

  /**
   * explains unavailable coverage; not a financial value
   *
   * @generated from field: string broker_finance_reason = 14;
   */
  brokerFinanceReason: string;

  /**
   * 451 closed_position_pnl, not assumed to be today's
   *
   * @generated from field: optional sint64 closed_position_pnl_cents = 15;
   */
  closedPositionPnlCents?: bigint | undefined;

  /**
   * Exact nonempty source fields from a successfully completed current 303 account list.
   * Empty/absent source strings remain absent; no local alias or default denomination.
   * Money rendering must verify a supported denomination; this does not convert its units.
   *
   * @generated from field: optional string broker_currency = 16;
   */
  brokerCurrency?: string | undefined;

  /**
   * @generated from field: optional string broker_account_name = 17;
   */
  brokerAccountName?: string | undefined;

  /**
   * Rithmic account-risk inputs from the producing actor's current order-plant connection
   * (ADR-0045). Absent = no order-plant coverage (disconnected, retired source, older server).
   *
   * @generated from field: optional helm.v1.BrokerRisk broker_risk = 18;
   */
  brokerRisk?: BrokerRisk | undefined;

  /**
   * HELM's record of the account's current trading day from the 451 values this gateway saw
   * (ADR-0047). Absent until the PnL feed reported the account. Display input only.
   *
   * @generated from field: optional helm.v1.DayTrack day_track = 19;
   */
  dayTrack?: DayTrack | undefined;

  /**
   * When each money field above was last set (ADR-0056). Rithmic's 451 updates carry only the
   * fields that changed, so a field keeps the last value Rithmic reported for it in the current
   * PnL-plant session and trading day; this says which update that was. Absent while no money is
   * current. Display only.
   *
   * @generated from field: optional helm.v1.FieldTimes field_times = 20;
   */
  fieldTimes?: FieldTimes | undefined;
};

/**
 * Describes the message helm.v1.AccountUpdate.
 * Use `create(AccountUpdateSchema)` to create a new message.
 */
export const AccountUpdateSchema: GenMessage<AccountUpdate> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 13);

/**
 * Per money field of AccountUpdate: the broker time (451 ssboe/usecs, ns since the epoch) of the
 * update that set the value shown (ADR-0056). 0 = the field is absent, or the update that set it
 * carried no broker time. Never a local receipt time.
 *
 * @generated from message helm.v1.FieldTimes
 */
export type FieldTimes = Message<"helm.v1.FieldTimes"> & {
  /**
   * balance_cents
   *
   * @generated from field: fixed64 balance_ns = 1;
   */
  balanceNs: bigint;

  /**
   * realized_today_cents
   *
   * @generated from field: fixed64 realized_today_ns = 2;
   */
  realizedTodayNs: bigint;

  /**
   * unrealized_cents
   *
   * @generated from field: fixed64 unrealized_ns = 3;
   */
  unrealizedNs: bigint;

  /**
   * day_pnl_cents
   *
   * @generated from field: fixed64 day_pnl_ns = 4;
   */
  dayPnlNs: bigint;

  /**
   * cash_on_hand_cents
   *
   * @generated from field: fixed64 cash_on_hand_ns = 5;
   */
  cashOnHandNs: bigint;

  /**
   * closed_position_pnl_cents
   *
   * @generated from field: fixed64 closed_position_pnl_ns = 6;
   */
  closedPositionPnlNs: bigint;
};

/**
 * Describes the message helm.v1.FieldTimes.
 * Use `create(FieldTimesSchema)` to create a new message.
 */
export const FieldTimesSchema: GenMessage<FieldTimes> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 14);

/**
 * The trading day in progress as HELM saw it (ADR-0047): the day's high water from 451 values
 * only, and whether the account's PnL feed has been live without a break since the session open
 * (HELM cannot know a peak while disconnected). Closed days are stored in
 * `account_daily_history` at each 17:00 CT rollover and read through the API.
 *
 * @generated from message helm.v1.DayTrack
 */
export type DayTrack = Message<"helm.v1.DayTrack"> & {
  /**
   * "YYYY-MM-DD": the CT date on which the day closes
   *
   * @generated from field: string trading_day = 1;
   */
  tradingDay: string;

  /**
   * 17:00 CT that began it (Sunday 17:00 for Monday)
   *
   * @generated from field: fixed64 session_open_ns = 2;
   */
  sessionOpenNs: bigint;

  /**
   * 17:00 CT that ends it
   *
   * @generated from field: fixed64 rollover_ns = 3;
   */
  rolloverNs: bigint;

  /**
   * live without a break since session_open_ns
   *
   * @generated from field: bool complete_so_far = 4;
   */
  completeSoFar: boolean;

  /**
   * start of the current live interval; 0 = not live now
   *
   * @generated from field: fixed64 live_since_ns = 5;
   */
  liveSinceNs: bigint;

  /**
   * max(451 account_balance + open_position_pnl) today
   *
   * @generated from field: optional sint64 high_equity_cents = 6;
   */
  highEquityCents?: bigint | undefined;

  /**
   * max(451 account_balance) today
   *
   * @generated from field: optional sint64 high_balance_cents = 7;
   */
  highBalanceCents?: bigint | undefined;

  /**
   * samples today while account_balance or open_position_pnl was not reported
   *
   * @generated from field: uint32 equity_samples_missing = 8;
   */
  equitySamplesMissing: number;

  /**
   * first value seen today; 0 = none
   *
   * @generated from field: fixed64 first_seen_ns = 9;
   */
  firstSeenNs: bigint;
};

/**
 * Describes the message helm.v1.DayTrack.
 * Use `create(DayTrackSchema)` to create a new message.
 */
export const DayTrackSchema: GenMessage<DayTrack> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 15);

/**
 * Rithmic's own account-risk values (ADR-0045): RMS update subscription 3508/3509, pushes 356,
 * RMS info 305. Exact source values only; absent = not reported. HELM derives no threshold,
 * peak or limit here. Clients derive drawdown / daily-loss room from these and AccountUpdate
 * money, show every input, and keep the result "unverified" until the owner records a
 * R|Trader Pro match (docs/RITHMIC-RTRADER-MATCH.md).
 *
 * @generated from message helm.v1.BrokerRisk
 */
export type BrokerRisk = Message<"helm.v1.BrokerRisk"> & {
  /**
   * this account's 3508 subscription on this connection
   *
   * @generated from field: helm.v1.BrokerRmsUpdates rms_updates = 1;
   */
  rmsUpdates: BrokerRmsUpdates;

  /**
   * Rithmic's refusal text, or why it is unavailable
   *
   * @generated from field: string rms_updates_detail = 2;
   */
  rmsUpdatesDetail: string;

  /**
   * 356 auto_liq_threshold_current_value (tag 131040), or the account list (303) asked for after
   * the subscription was accepted. Present only while rms_updates = ACCEPTED.
   *
   * @generated from field: optional sint64 auto_liq_threshold_cents = 3;
   */
  autoLiqThresholdCents?: bigint | undefined;

  /**
   * the exact Rithmic string
   *
   * @generated from field: string auto_liq_threshold_raw = 4;
   */
  autoLiqThresholdRaw: string;

  /**
   * @generated from field: helm.v1.BrokerRiskSource auto_liq_threshold_source = 5;
   */
  autoLiqThresholdSource: BrokerRiskSource;

  /**
   * gateway receipt time (not a broker time)
   *
   * @generated from field: fixed64 auto_liq_threshold_received_ns = 6;
   */
  autoLiqThresholdReceivedNs: bigint;

  /**
   * 356 auto_liq_peak_account_balance (131049)
   *
   * @generated from field: optional sint64 auto_liq_peak_balance_cents = 7;
   */
  autoLiqPeakBalanceCents?: bigint | undefined;

  /**
   * @generated from field: string auto_liq_peak_balance_raw = 8;
   */
  autoLiqPeakBalanceRaw: string;

  /**
   * 356 ..._ssboe (131050); 0 = absent or not a time
   *
   * @generated from field: fixed64 auto_liq_peak_balance_broker_ns = 9;
   */
  autoLiqPeakBalanceBrokerNs: bigint;

  /**
   * gateway receipt time
   *
   * @generated from field: fixed64 auto_liq_peak_received_ns = 10;
   */
  autoLiqPeakReceivedNs: bigint;

  /**
   * a correlated 305 arrived on this connection
   *
   * @generated from field: bool rms_info_current = 11;
   */
  rmsInfoCurrent: boolean;

  /**
   * gateway receipt time of that 305
   *
   * @generated from field: fixed64 rms_info_received_ns = 12;
   */
  rmsInfoReceivedNs: bigint;

  /**
   * 305 loss_limit: absent / no-limit / zero / value
   *
   * @generated from field: helm.v1.BrokerLossLimit loss_limit_state = 13;
   */
  lossLimitState: BrokerLossLimit;

  /**
   * only with loss_limit_state = VALUE
   *
   * @generated from field: optional sint64 loss_limit_cents = 14;
   */
  lossLimitCents?: bigint | undefined;

  /**
   * 305, exact string
   *
   * @generated from field: string auto_liquidate_criteria = 15;
   */
  autoLiquidateCriteria: string;

  /**
   * 305 AutoLiquidateFlag as sent: 0 unset, 1 enabled, 2 disabled
   *
   * @generated from field: int32 auto_liquidate = 16;
   */
  autoLiquidate: number;

  /**
   * 305 configured threshold (not the current value)
   *
   * @generated from field: optional sint64 rms_auto_liquidate_threshold_cents = 17;
   */
  rmsAutoLiquidateThresholdCents?: bigint | undefined;

  /**
   * 305 min_account_balance (presence bit)
   *
   * @generated from field: optional sint64 rms_min_account_balance_cents = 18;
   */
  rmsMinAccountBalanceCents?: bigint | undefined;

  /**
   * 305 auto_liquidate_max_min_account_balance
   *
   * @generated from field: optional sint64 rms_auto_liq_max_min_balance_cents = 19;
   */
  rmsAutoLiqMaxMinBalanceCents?: bigint | undefined;
};

/**
 * Describes the message helm.v1.BrokerRisk.
 * Use `create(BrokerRiskSchema)` to create a new message.
 */
export const BrokerRiskSchema: GenMessage<BrokerRisk> = /*@__PURE__*/
  messageDesc(file_helm_v1_trading, 16);

/**
 * @generated from enum helm.v1.ExitKind
 */
export enum ExitKind {
  /**
   * @generated from enum value: EXIT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXIT_KIND_EXIT_AND_CANCEL_SYMBOL = 1;
   */
  EXIT_AND_CANCEL_SYMBOL = 1,

  /**
   * @generated from enum value: EXIT_KIND_REVERSE_AND_CANCEL_SYMBOL = 2;
   */
  REVERSE_AND_CANCEL_SYMBOL = 2,

  /**
   * @generated from enum value: EXIT_KIND_CANCEL_SYMBOL_ORDERS = 3;
   */
  CANCEL_SYMBOL_ORDERS = 3,

  /**
   * @generated from enum value: EXIT_KIND_CANCEL_BIDS = 4;
   */
  CANCEL_BIDS = 4,

  /**
   * @generated from enum value: EXIT_KIND_CANCEL_OFFERS = 5;
   */
  CANCEL_OFFERS = 5,

  /**
   * @generated from enum value: EXIT_KIND_CANCEL_ALL_ACCOUNT = 6;
   */
  CANCEL_ALL_ACCOUNT = 6,

  /**
   * @generated from enum value: EXIT_KIND_FLATTEN_ACCOUNT = 7;
   */
  FLATTEN_ACCOUNT = 7,

  /**
   * @generated from enum value: EXIT_KIND_FLATTEN_ALL_ACCOUNTS = 8;
   */
  FLATTEN_ALL_ACCOUNTS = 8,
}

/**
 * Describes the enum helm.v1.ExitKind.
 */
export const ExitKindSchema: GenEnum<ExitKind> = /*@__PURE__*/
  enumDesc(file_helm_v1_trading, 0);

/**
 * @generated from enum helm.v1.BrokerRmsUpdates
 */
export enum BrokerRmsUpdates {
  /**
   * @generated from enum value: BROKER_RMS_UPDATES_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * HELM_RITHMIC_RMS_UPDATES=off on this gateway
   *
   * @generated from enum value: BROKER_RMS_UPDATES_OFF = 1;
   */
  OFF = 1,

  /**
   * requested, Rithmic has not answered yet
   *
   * @generated from enum value: BROKER_RMS_UPDATES_PENDING = 2;
   */
  PENDING = 2,

  /**
   * 3509 rp_code 0
   *
   * @generated from enum value: BROKER_RMS_UPDATES_ACCEPTED = 3;
   */
  ACCEPTED = 3,

  /**
   * 3509 error, or a Reject (75) of the request
   *
   * @generated from enum value: BROKER_RMS_UPDATES_REFUSED = 4;
   */
  REFUSED = 4,

  /**
   * no answer within the gateway's wait
   *
   * @generated from enum value: BROKER_RMS_UPDATES_NO_ANSWER = 5;
   */
  NO_ANSWER = 5,
}

/**
 * Describes the enum helm.v1.BrokerRmsUpdates.
 */
export const BrokerRmsUpdatesSchema: GenEnum<BrokerRmsUpdates> = /*@__PURE__*/
  enumDesc(file_helm_v1_trading, 1);

/**
 * @generated from enum helm.v1.BrokerRiskSource
 */
export enum BrokerRiskSource {
  /**
   * @generated from enum value: BROKER_RISK_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 356 push
   *
   * @generated from enum value: BROKER_RISK_SOURCE_RMS_UPDATE = 1;
   */
  RMS_UPDATE = 1,

  /**
   * 303 asked for after the 356 subscription was accepted
   *
   * @generated from enum value: BROKER_RISK_SOURCE_ACCOUNT_LIST = 2;
   */
  ACCOUNT_LIST = 2,
}

/**
 * Describes the enum helm.v1.BrokerRiskSource.
 */
export const BrokerRiskSourceSchema: GenEnum<BrokerRiskSource> = /*@__PURE__*/
  enumDesc(file_helm_v1_trading, 2);

/**
 * @generated from enum helm.v1.BrokerLossLimit
 */
export enum BrokerLossLimit {
  /**
   * no correlated 305 yet
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 305 presence bit not set
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_ABSENT = 1;
   */
  ABSENT = 1,

  /**
   * Rithmic's 9,999,999 "no limit" placeholder (discrepancies #27)
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_NO_LIMIT = 2;
   */
  NO_LIMIT = 2,

  /**
   * reported 0: meaning unverified, never treated as a limit
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_ZERO = 3;
   */
  ZERO = 3,

  /**
   * negative or not a finite number
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_INVALID = 4;
   */
  INVALID = 4,

  /**
   * a positive amount below the placeholder
   *
   * @generated from enum value: BROKER_LOSS_LIMIT_VALUE = 5;
   */
  VALUE = 5,
}

/**
 * Describes the enum helm.v1.BrokerLossLimit.
 */
export const BrokerLossLimitSchema: GenEnum<BrokerLossLimit> = /*@__PURE__*/
  enumDesc(file_helm_v1_trading, 3);

